import { render } from "./ScrollToTop.vue?vue&type=template&id=1848f8f4"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=1848f8f4&lang=scss"

import exportComponent from "/home/sc1nboq9356/staging-meiser/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__